@if (!isWarning) {
  <div
    [ngClass]="{ isCancel: isCancel }"
    class="modal solid confirmModal open"
    id="ConfirmModal{{ appendId }}"
    >
    @if (!isTimeoutWarning) {
      <div (click)="cancel()" class="close cancel" id="CancelXButton{{ appendId }}"></div>
    }
    @if (isTimeoutWarning) {
      <div (click)="confirm()" class="close cancel" id="CancelXButton{{ appendId }}"></div>
    }
    <div class="icon {{ icon }}"></div>
    <div class="title">{{ title }}</div>
    @if (showWarning) {
      <div class="domainName">{{domainName}}</div>
    }
    <div [ngClass]="{ isDestructive: isDestructive, isCancel: isCancel }" class="subtitle">
      <div class="scroll">
        @if (useInnerHtml) {
          <div [innerHtml]="subtitle"></div>
        }
        @if (!useInnerHtml) {
          <div>{{ subtitle }}</div>
        }
        @if (bulletList.length > 0) {
          <div class="bullets" id="BulletList">
            <ul>
              @for (item of bulletList; track item) {
                <li
                  (click)="!!bulletListOnClick && bulletListOnClick(item, context)"
                  [ngClass]="{ bulletClick: !!bulletListOnClick }"
                  >
                  <a href="{{ item.src }}">{{ item.name ||  item.domainName || item.id || item.description}}</a>
                </li>
              }
            </ul>
          </div>
        }
        @if (afterListText) {
          <div class="after-list-text">
            {{ afterListText }}
          </div>
        }
        @if (secondBulletList.length > 0) {
          <div class="bullets" id="BulletList">
            <ul>
              @for (item of secondBulletList; track item) {
                <li
                  (click)="!!secondBulletListOnClick && secondBulletListOnClick(item, context)"
                  [ngClass]="{ bulletClick: !!secondBulletListOnClick }"
                  >
                  {{ item.name || item }}
                </li>
              }
            </ul>
          </div>
        }
      </div>
      @if (isDestructive) {
        <div>
          @if (isMove) {
            <div  class="row moveInfo">
                <div>Moving from: <strong>{{ fromProvider }}</strong> / <strong>{{ fromRegion }}</strong></div>
                <div>Moving to: <strong>{{ toProvider }}</strong> / <strong>{{ toRegion }}</strong></div>
            </div>
          }
          <div class="row deleteRow deleteLabel label">
            Type "{{this.isCancel ? 'cancel' : this.isOffboard ? 'offboard' : this.isFips ? 'enable' : this.isMove ? 'move' : 'delete'}}  <span id="deleteName">{{ itemName }}"</span> to confirm
          </div>
          <div class="row deleteRow">
            <input
              [(ngModel)]="confirmString"
              [ngClass]="{ error: errorConfirm }"
              id="ConfirmDelete"
              placeholder="{{ placeholder }}"
              type="text"
              />
            </div>
          </div>
        }
        @if (showWarning) {
          <div>
            <app-message
              severity="warn"
              text="Please note that this may cause some downtime with the network controller due to the addition of the Public Certificate."
            ></app-message>
          </div>
        }
        @if (isRestoreModal) {
          <div class="restorePortion">
            You can try restoring it by clicking RESTORE below or reach out to our support team <a (click)="openTicket()">here.</a>
          </div>
        }
      </div>
      <div class="buttons">
        @if (!hideCancelLink) {
          <div (click)="cancel()" class="linkButton cancel" id="CancelConfirmButton{{ appendId }}">
            {{ cancelAction }}
          </div>
        }
        @if (action && action !== '') {
          <button
            (click)="confirm()"
            class="save alert confirm"
            id="ConfirmAction{{ appendId }}"
            >
            {{ action }}
          </button>
        }
      </div>
    </div>
  }

  <!--
  Differnt styles for when displaying as a warning for the HA gateway upgrade
  The original plan was to handle this with the ngClass directive. However, doing so would cause the classes to update after the
  view initialized. This caused the dialog to have an expanding effect as it was displayed
  The quick solution was to use ngIf to handle the cases separtely
  -->

  @if (isWarning) {
    <div class="modal solid confirmModal open warning" id="ConfirmModal{{ appendId }}">
      <div (click)="cancel()" class="close cancel" id="CancelXButton{{ appendId }}"></div>
      <div class="icon {{ icon }}"></div>
      <div class="title">{{ title }}</div>
      <div class="subtitle">
        {{ subtitle }}
        @if (bulletList.length > 0) {
          <div class="bullets" id="BulletList">
            <ul class="bulletListNotAllowed">
              @for (item of bulletList; track item) {
                <li
                  (click)="!!bulletListOnClick && bulletListOnClick(item, context)"
                  [ngClass]="{ bulletClick: !!bulletListOnClick }"
                  >
                  {{ item.name }}
                </li>
              }
            </ul>
          </div>
        }
      </div>
      <div class="buttons">
        <button (click)="confirm()" class="save alert confirm" id="ConfirmAction{{ appendId }}">
          {{ action }}
        </button>
      </div>
    </div>
  }
